<template>
  <div class="login-bg" :style="{height: (height > 586 ? height : 586) + 'px'}" >
    <p style="height: 200px"></p>
    <el-row >
      <el-col :xs="2" :sm="7" :md="8"></el-col>
      <el-col :xs="20" :sm="10" :md="8">
        <el-card >
          <template #header >
            <h3 style="text-align: center;letter-spacing: 3px">
              <el-text style="font-size: 16px">用户登录</el-text>
            </h3>
          </template>
          <el-form :model="loginInfo" label-width="120px" label-position="top">
            <el-form-item label="">
              <el-input  v-model="loginInfo.username" placeholder="请输入用户名"  @keyup.enter="onLogin">
                <template #prepend>用户名</template>
              </el-input>
            </el-form-item>
            <el-form-item label="" style="margin-top: 50px">
              <el-input v-model="loginInfo.password" type="password" placeholder="请输入密码"  @keyup.enter="onLogin">
                <template #prepend>密 <span style="color: transparent">占</span> 码</template>
              </el-input>
            </el-form-item>
            <el-button type="primary" style="width: 100%;letter-spacing: 2px;margin-top: 20px" @click="onLogin" :loading="loading" ref="actionBtn">登录</el-button>
          </el-form>
          <template #footer>
            <PageFooter/>
          </template>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>

import {reactive, ref} from "vue";
import {post} from "@/assets/js/utils";
import {ElMessage} from "element-plus";
import {useRouter} from "vue-router/dist/vue-router";
import PageFooter from "@/components/PageFooter";
import {useSize} from "@/assets/js/size";
let {height} = useSize()
let router = useRouter();

const loginInfo = reactive({
  username:'',
  password: ''
})
const loading = ref(false);
const onLogin = function (){
  loading.value = true;
  let postData = {
    username: loginInfo.username,
    password: loginInfo.password
  }
  post('/login', postData, ({code, data, message}) => {
    if (code == 0){
      localStorage.setItem('user', JSON.stringify(data.data))
      setTimeout(() => {
        router.push("/");
      }, 1000)
    }
    ElMessage({message, type: code == 0 ? 'success' : 'info'})
  }, null, () =>  loading.value = false)
}

</script>

<style scoped>

</style>